module.exports = __webpack_public_path__ + "img/yxlnm_IOS.fdcef5f5.png";